export default __webpack_public_path__ + "static/media/se-vijeo.e5d7674c.png";